<template lang="pug">

  transition(name='normal' mode="out-in" appear)
    swiper.DrawerSampleList(:options="swiperOption" @progress="swiperProgressHandler")
      swiper-slide.DrawerSampleList_item(v-for="(item, index) in samples" :key="item.id")
        SampleListItem(:item="item" class="SampleListItem-in-drawer")
      span.swiper-scrollbar.DrawerSampleList_scrollbar(slot="scrollbar")
</template>

<script>

import SampleListItem from '@/components/SampleListItem'
import scrollUpdate from '@/mixins/scrollUpdate'

export default {
  props: ['samples'],
  mixins: [scrollUpdate],
  components: {
    SampleListItem
  },
  mounted () {
    this.$el.addEventListener('wheel', this.onWheel)
  },
  beforeDestroy () {
    this.$el.removeEventListener('wheel', this.onWheel)
  },
  methods: {
    onWheel (e) {
      if (this.isActive && this.swiperProgress > 0) {
        e.preventDefault()
        e.stopImmediatePropagation()
      }
    },
    onProgress (p, pv) {
      this.isActive = p < 1
    },
    swiperProgressHandler (p) {
      this.swiperProgress = p
    }
  },
  data () {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        freeMode: true,
        freeModeMomentum: true,
        mousewheel: true,
        scrollbar: {
          el: '.DrawerSampleList_scrollbar'
          // hide: true
        }
      },
      isActive: false,
      swiperProgress: 0
    }
  }
}

</script>

<style lang="stylus" scope>

.DrawerSampleList
  background-color $grey-1
  width 100%
  z-index: 0

  .DrawerSampleList_item
    width 65vw
    max-width 330px

  .DrawerSampleList_scrollbar
    bottom 0px
    background-color transparent

    @media $mq_s_only
      height 3px

    .swiper-scrollbar-drag
      background-color $beige
      border-radius: 0

</style>
